import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconPercentage.module.css';

const IconPercentage = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" stroke="currentColor" stroke-width="1.2">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
    </svg>

  );
};

IconPercentage.defaultProps = {
  rootClassName: null,
  className: null,
};

IconPercentage.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconPercentage;
